import { Garage, ID } from "@App/types";

export const garageWithEarliestAvailability = (garages: Garage[]): Garage | null => {
  // iterates and reduces through the garages that would be viable for badges, reduces by comparing available booking days to filter out
  // ones that have no available days, then comparing available at to
  // find the one with the earliest available date
  return (
    garages.reduce(function (prev, curr) {
      const prevDays = prev.available_days?.length;
      const currDays = curr.available_days?.length;

      // If only one has available days, prefer that one
      if (prevDays && !currDays) return prev;
      if (!prevDays && currDays) return curr;
      // If neither has available days, keep the previous
      if (!prevDays && !currDays) return prev;

      // should not happen due to above checks, but just in case
      if (!prev.available_days || !curr.available_days) return prev;

      // Otherwise, compare earliest available dates
      return prev.available_days[0].available_at <= curr.available_days[0].available_at
        ? prev
        : curr;
    }) || null
  );
};
export const garageAuthorizedForBrand = (garages: Garage[], brandId: ID): Garage | null => {
  return garages.find((garage) => garage.authorizedBrands?.find((b) => b.id === brandId)) ?? null;
};
